import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';
import { ApprovalState } from '@lichtblick/types';

export const RootContainer = styled.div`
  align-items: flex-start;

  color: ${Colors.gray[100]};
  display: flex;
  font-style: normal;
  gap: 0.62rem;
  height: 0.25rem;
  justify-content: center;
  letter-spacing: 0.0625rem;
  min-width: 9.875rem;
  text-align: right;

  > span {
    line-height: 1.2rem;
  }

  > div {
    width: 100%;
  }
`;

export const BarContainer = styled.div`
  align-items: flex-start;
  align-self: stretch;
  border-radius: 0.375rem;
  display: flex;
  gap: ${Spacing['4Xs']};
  height: 0.25rem;
  justify-content: space-between;
  margin: auto;
  overflow: hidden;
`;

export const Bar = styled.div<{ $status: ApprovalState }>`
  background-color: ${({ $status }) => {
    switch ($status) {
      case ApprovalState.ServerApproved:
      case ApprovalState.ClientApproved:
        return Colors.green[100];
      case ApprovalState.Rejected:
        return Colors.red[100];
      case ApprovalState.Pending:
        return Colors.orange[100];
      case ApprovalState.Resubmitted:
        return Colors.orange[100];
      case ApprovalState.Open:
        return Colors.gray[100];
      default:
        return Colors.gray[100];
    }
  }};
  border-radius: ${BorderRadius.Xxs};
  cursor: pointer;
  height: inherit;
  width: 100%;
`;
